import { RootState } from 'store';

export const localeSelector = (state: RootState) => state.locale.code;
export const supportEmailSelector = (state: RootState) =>
  state.locale.supportEmail;
